import { StyledDatepicker } from './Datepicker.styles';
import { U1Datepicker } from '@u1/react-a11y-hooks';
import { DatepickerProps, DatepickerType } from './Datepicker.consts';
import { DatepickerSingle } from './Sections/DatepickerSingle';
import { DatepickerRange } from './Sections/DatepickerRange';

export const Datepicker: React.FC<DatepickerProps> = ({
  presetDate,
  type,
  onRangeSelect,
  onSingleDateSelect,
}: DatepickerProps) => {
  return (
    <U1Datepicker>
      <StyledDatepicker $gap={32}>
        {type === DatepickerType.RANGE ? (
          <DatepickerRange onRangeSelect={onRangeSelect} />
        ) : (
          <DatepickerSingle presetDate={presetDate} onSingleDateSelect={onSingleDateSelect} />
        )}
      </StyledDatepicker>
    </U1Datepicker>
  );
};
